function isInput(el) {
  if (el instanceof HTMLElement) {
    return el?.tagName.toLowerCase() === "input";
  }
  return false;
}
export function handleMoveToNextInput(e) {
  const target = e.target;
  const maxLength = parseInt(target.dataset.maxLength || "1", 10);
  const myLength = isInput(target) ? target.value.length : maxLength;
  if (myLength >= maxLength) {
    let next = target;
    while (next = next.nextElementSibling) {
      if (next == null) break;
      if (isInput(next)) {
        next.focus();
        next.click();
        break;
      }
    }
  } else if (myLength === 0 && ["Backspace", "Delete"].includes(e.key)) {
    let previous = target;
    while (previous = previous.previousElementSibling) {
      if (previous == null) break;
      if (isInput(previous)) {
        previous.focus();
        previous.click();
        break;
      }
    }
  }
}
export function handleFocusOtpInput(e) {
  const target = e.target;
  if (isInput(target)) {
    target.select();
  }
}
export function handleInvalidNumberKeys(e) {
  const INVALID_KEYS = ["e", "+", "-"];
  if (INVALID_KEYS.includes(e.key)) {
    e.preventDefault();
  }
}
